const getDiscount = ({ oldPrice, newPrice }) =>
  Math.floor((oldPrice * 1000 - newPrice * 1000) / (oldPrice * 10));

export default getDiscount;
